import { Button, Col, Form, FormControl, Row } from 'react-bootstrap'
import React, { useEffect, useRef, useState } from 'react'
import { withStore } from '@bigyellow/store'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { handle_api_exception } from '@bigyellow/api/exception'
import { totp_confirm, totp_request } from '@bigyellow/api/register'
import { token } from '@bigyellow/api/auth'

const NewTotp = ({
  store,
  isRegistration = false,
  description,
  inQrCodedDetails = null,
  onComplete
}) => {

  const http_client = store.get('http_client')
  const notify = store.get('notify')
  const [submitting, setSubmitting] = useState(false)
  const [qrCodeDetails, setQrCodeDetails] = useState(inQrCodedDetails)
  const [showSecret, setShowSecret] = useState(false)
  const secretKeyRef = useRef()
  //url encode the issuer

  useEffect(() => {
    if (!qrCodeDetails) {
      requestNewQRCode()
    }
  }, [qrCodeDetails])

  const schema = Yup.object().shape({
    code: Yup.string().required('This field is required')
  })

  const requestNewQRCode = async () => {
    try {
      setSubmitting(true)
      const res = await totp_request(http_client)
      setQrCodeDetails(res.data.data)

    } catch (err) {
      if (notify) {
        notify(handle_api_exception(err), { type: 'error' })
      }

    } finally {
      setSubmitting(false)
    }
  }
  const onSubmitNewVerificationCOde = async (code) => {
    setSubmitting(true)
    try {
      const func = isRegistration ? token : totp_confirm
      const res = await func(http_client, { code: code })
      const { data, code: statusCode } = res.data
      if (statusCode === 200) {
        onComplete(data) // Resolve the promise if successful
      } else {
        alert('Oooops. There was a problem.')
      }
    } catch (err) {
      if (notify) {
        notify(handle_api_exception(err), { type: 'error' })
      }
    } finally {
      setSubmitting(false)
    }
  }

  // Function to copy text to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      if (notify) {
        notify('Setup key copied to clipboard', { type: 'success' })
      }
    }).catch(err => {
      if (notify) {
        notify('Failed to copy setup key', { type: 'error' })
      }
    })
  }

  useEffect(() => {
    if (showSecret) {
      secretKeyRef.current.focus()
      secretKeyRef.current.select()
      // copyToClipboard(qrCodeDetails.secret)
    }
  }, [showSecret])

  return (
    <React.Fragment>
      <Row className={'mb-4'}>
        <Col>

          <p>Open your authenticator app and scan the QR code below.</p>

          {qrCodeDetails &&
            <>
              <a href={qrCodeDetails.otp_auth_uri}>
                <img src={qrCodeDetails.qr_code} alt="QR Code" className={'d-block mx-auto'} />
              </a></>}
        </Col>
        <Col>  {qrCodeDetails && <>
          <p className={'font-weight-bold text-sm '}>Unable to scan?</p>
          <p className={'text-sm text-wrap'}>Click the QR code, to open your authenticator app.<br />
            OR<br />
            If you need the setup key, <a className={'btn-link'} href={'#'} onClick={() => { setShowSecret(true) }}>click
              here</a>.</p>
        </>}
          {
            showSecret && qrCodeDetails && <>
              <FormControl
                ref={secretKeyRef}
                id={'secretKey'}
                type="text"
                className={'text-sm'}
                value={qrCodeDetails.secret}
                readOnly
                onClick={(e) => {
                  e.target.select()
                  copyToClipboard(qrCodeDetails.secret)
                }}
              />
            </>

          }
        </Col>
      </Row>
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={(values) => { onSubmitNewVerificationCOde(values.code) }}
        initialValues={{ code: '' }}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors
        }) => (
          <Form
            noValidate
            onSubmit={handleSubmit}
            id="verifyCodeForm"
            autoComplete="off"
          >
            <React.Fragment>
              {
                <Row className={'mb-4'}>
                  <Col>
                    <p className={'m-0'}>Please enter the code from your authentication app</p>
                  </Col>
                </Row>
              }
              <Form.Row>
                <Form.Group
                  as={Col}
                  controlId="validationPhone"
                  className="material material label-top"
                >
                  <FormControl
                    type="text"
                    name="code"
                    value={values.code}
                    onChange={handleChange}
                    isInvalid={
                      touched.code && errors.code
                    }
                  />
                  <Form.Label>Verification code</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.code}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Row className={'my-1'}>
                <Col className={`text-center`}>
                  <Button
                    type="submit"
                    variant="primary"
                    className={'btn-wide'}
                    disabled={submitting}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </React.Fragment>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  )

}

export default withStore(NewTotp)